<template>
  <button
    class="frisbuy-arrow-button"
    :class="[
      `frisbuy-arrow-button--${props.direction}`,
      customClass,
      { '--disabled': isDisabled },
    ]"
    @click="clickHandler"
  >
    <svg width="16" height="30" viewBox="0 0 16 30" fill="none">
      <path
        d="M13.645 0.820039L0.71502 14.14C0.480853 14.3742 0.36377 14.6542 0.36377 14.98C0.36377 15.3059 0.480853 15.5988 0.71502 15.8588L13.645 29.1788C13.8792 29.3871 14.1525 29.4913 14.465 29.4913C14.7775 29.4913 15.0509 29.3742 15.285 29.14C15.5192 28.9059 15.6363 28.6325 15.6363 28.32C15.6363 28.0075 15.5192 27.7342 15.285 27.5L3.09752 15L15.285 2.50004C15.5192 2.26587 15.6363 1.99254 15.6363 1.68004C15.6363 1.36754 15.5192 1.09421 15.285 0.860039C15.0509 0.625873 14.7775 0.508789 14.465 0.508789C14.1525 0.508789 13.8792 0.612956 13.645 0.821289V0.820039Z"
        :fill="isDisabled && fillColorDisabled ? fillColorDisabled : fillColor"
      />
    </svg>
  </button>
</template>

<style scoped lang="scss">
.frisbuy-arrow-button {
  display: block;
  position: absolute;

  top: 50%;
  transform: translateY(-50%);

  width: 40px;
  height: 40px;

  background-color: transparent;
  border: none;

  cursor: pointer;

  &.--disabled {
    pointer-events: none;
  }

  svg {
    display: block;
    height: 80%;
    margin: auto;
  }

  &--left {
    left: 0;
  }

  &--right {
    right: 0;

    svg {
      scale: -1 1;
    }
  }
}
</style>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    direction?: "left" | "right";
    customClass?: string;
    isDisabled?: boolean;
    fillColor?: string;
    fillColorDisabled?: string;
  }>(),
  {
    direction: "left",
    isDisabled: false,
    fillColor: "#606266",
  }
);

const emit = defineEmits(["click"]);

function clickHandler() {
  emit("click");
}
</script>
